import {
  afterRenderEffect,
  ChangeDetectionStrategy,
  Component,
  inject,
  model,
  signal,
} from '@angular/core';
import { AffiliatesService } from '@features/engagement/affiliates/services/affiliates.service';
import { BalanceIconComponent } from '@core/components/balance-icon/balance-icon.component';
import { ToastrService } from 'ngx-toastr';
import { ModalService } from '@core/modals/services/modal.service';
import { SvgIconComponent } from 'angular-svg-icon';
import { FormFieldComponent } from '@core/components/form-field/form-field.component';

@Component({
  selector: 'app-reedem-promocode-modal',
  imports: [BalanceIconComponent, SvgIconComponent, FormFieldComponent],
  templateUrl: './reedem-promocode-modal.component.html',
  styleUrl: './reedem-promocode-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  host: {
    class: 'modal-container flex flex-col',
  },
})
export class ReedemPromocodeModalComponent {
  private readonly affiliatesService = inject(AffiliatesService);
  private readonly toastrService = inject(ToastrService);
  private readonly modalService = inject(ModalService);

  initialCode = model<string>('');
  code = model<string>('');
  errors = model<{ required: string | null; api: string | null }>({
    required: null,
    api: null,
  });

  public isLoading = signal<boolean>(false);

  constructor() {
    const initCodeEffect = afterRenderEffect(() => {
      if (this.initialCode().length > 0) {
        this.code.set(this.initialCode());
        initCodeEffect.destroy();
      }
    });
  }

  public async redeemPromocode() {
    const code = this.code().trim();

    if (code.length === 0) {
      this.errors.update((prev) => ({
        ...prev,
        required: 'Promo code is required',
      }));
      return;
    }

    this.isLoading.set(true);
    this.errors.set({ required: null, api: null });

    try {
      const message = await this.affiliatesService.usePromoCode(code);
      this.toastrService.success(message);
      this.modalService.close();
    } catch (error: any) {
      this.errors.update((prev) => ({ ...prev, api: error }));
    } finally {
      this.isLoading.set(false);
    }
  }
}
